import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowDown_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.7071 17.2929C27.0976 17.6834 27.0976 18.3166 26.7071 18.7071L16.7071 28.7071C16.3166 29.0976 15.6834 29.0976 15.2929 28.7071L5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929C5.68342 16.9024 6.31658 16.9024 6.70711 17.2929L15 25.5858L15 4C15 3.44771 15.4477 3 16 3C16.5523 3 17 3.44771 17 4L17 25.5858L25.2929 17.2929C25.6834 16.9024 26.3166 16.9024 26.7071 17.2929Z"
            />
        </SvgStyled>
    );
};

export default ArrowDown_lg;
